/**
 * useToast — Hook per emettere toast.
 *
 * Uso:
 *   const toast = useToast();
 *   toast({ severity: 'success', message: t('common.saved') });
 *
 * Richiede <ToastProvider> in un ancestor. Lancia errore se usato fuori contesto.
 */

import { useContext } from 'react';
import { ToastContext } from './ToastProvider';

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error('useToast deve essere usato dentro un <ToastProvider>');
  }
  return ctx.push;
}
